var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2DiscountWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 62,
    viewBox: "0 0 58 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1478_19855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7731 52.1395C33.0481 52.8645 32.172 53.227 31.145 53.227C30.1179 53.227 29.2418 52.8645 28.5168 52.1395L5.86058 29.4833C5.4578 29.0805 5.18593 28.6576 5.04495 28.2145C4.90398 27.7714 4.8335 27.3083 4.8335 26.8249V8.45825C4.8335 7.41103 5.17586 6.54506 5.86058 5.86034C6.5453 5.17561 7.41127 4.83325 8.4585 4.83325H26.8252C27.3085 4.83325 27.7918 4.90374 28.2752 5.04471C28.7585 5.18568 29.2016 5.45756 29.6043 5.86034L52.1398 28.3958C52.905 29.161 53.2877 30.0572 53.2877 31.0843C53.2877 32.1114 52.905 33.0076 52.1398 33.7728L33.7731 52.1395ZM14.8022 17.8833C15.6481 17.8833 16.3832 17.5711 17.0075 16.9468C17.6318 16.3225 17.9439 15.5874 17.9439 14.7416C17.9439 13.8958 17.6318 13.1607 17.0075 12.5364C16.3832 11.9121 15.6481 11.5999 14.8022 11.5999C13.9564 11.5999 13.2213 11.9121 12.597 12.5364C11.9727 13.1607 11.6606 13.8958 11.6606 14.7416C11.6606 15.5874 11.9727 16.3225 12.597 16.9468C13.2213 17.5711 13.9564 17.8833 14.8022 17.8833Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1478_19855",
    x: -4,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_19855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1478_19855",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2DiscountWhite);
export default __webpack_public_path__ + "static/media/v2-discount-white.47b44e6d5dfe15a1e2769b59b5768c5b.svg";
export { ForwardRef as ReactComponent };